import { render, staticRenderFns } from "./ContingentQuotaTDCAgro.vue?vue&type=template&id=4be573b4&"
import script from "./ContingentQuotaTDCAgro.vue?vue&type=script&lang=js&"
export * from "./ContingentQuotaTDCAgro.vue?vue&type=script&lang=js&"
import style0 from "./ContingentQuotaTDCAgro.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports